import {useEvent} from 'Event/EventProvider'
import React from 'react'
import {HighLevelTag} from 'Event/highlevel'
import IntegrationTagField from 'organization/Event/DashboardConfig/IntegrationTagField'
import TagsAutocomplete from 'organization/Event/Services/Apps/HighLevel/Config/TagsAutocomplete'

export default function HighLevelTagInput(props: {
  onChange: (tag: HighLevelTag | null) => void
  value?: HighLevelTag | null
  inputVariant?: 'filled' | 'standard' | 'outlined'
  disabled?: boolean
  label?: string
}) {
  const {disabled, value, onChange, inputVariant, label} = props
  const {event} = useEvent()

  if (!event.has_highlevel) {
    return null
  }

  return (
    <IntegrationTagField>
      <TagsAutocomplete
        value={value?.name ?? null}
        onChange={(name) => onChange(name ? {name} : null)}
        inputVariant={inputVariant ?? 'outlined'}
        inputLabel={label ?? 'High Level Tag'}
        disabled={disabled}
      />
    </IntegrationTagField>
  )
}
